import { Tooltip } from "react-tooltip";
import InfoIcon from "SVGS/InfoIcon";
import { withFeatureSafe } from "Common/ErrorBoundaries";

function CustomTextarea({
  label,
  toolTip,
  Icon,
  iconClass,
  required,
  labelClass,
  extraClass,
  maxWidth = "500px",
  maxHeight = "400px",
  ...inputProps
}) {
  const IconComponent = Icon || InfoIcon;
  return (
    <div className="flex flex-col">

      {label && (
        <div><label
          htmlFor="name"
          className={`${labelClass
              ? labelClass
              : `text-secondary font-medium text-sm ${required ? "required" : ""}`
            }`}
        >
          {label}
         </label>
        {toolTip && <> <IconComponent className={`inline ${iconClass}`} size={14} data-tooltip-id={`${label}-tooltip`} data-tooltip-content={toolTip} />
                <Tooltip id={`${label}-tooltip`} style={{ zIndex: 2, maxWidth: 220 }} /></>}   
         </div> 
      )}
      <textarea
        {...inputProps}
        onChange={(e) => {
          inputProps.onChange({
            target: { value: e.target.value.trimStart(), name: e.target.name, dataset: e.target.dataset },
          });
        }}
        // onPaste={(e) => {
        //   e.preventDefault();

        //   const pastedText = e.clipboardData.getData("text");
        //   const currentText = e.target.value;

        //   const combinedText = (currentText + pastedText).slice(0, 500);

        //   if (inputProps.onChange) {
        //     inputProps.onChange({
        //       target: { value: combinedText, name: e.target.name },
        //     });
        //   }
        // }}
        className={`p-[0.4rem] mt-2 focus:shadow-md !shadow-primaryColor/10 focus:border-primaryColor border border-gray-200 disabled:bg-gray-50 focus:outline-none focus:ring-0 rounded text-gray-900 ${extraClass}`}
        style={{ maxWidth: maxWidth, maxHeight: maxHeight, overflow: "auto" }} // Set maxWidth and maxHeight here
      />
    </div>
  );
}

export default withFeatureSafe(CustomTextarea);
